import { render, staticRenderFns } from "./section_description_preview.vue?vue&type=template&id=2f3beb37&"
import script from "./section_description_preview.vue?vue&type=script&lang=js&"
export * from "./section_description_preview.vue?vue&type=script&lang=js&"
import style0 from "./section_description_preview.vue?vue&type=style&index=0&id=2f3beb37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports